import { useState } from 'react'

/**
 * Aviso honesto para acciones del panel ww sin respaldo en la réplica
 * (no hay endpoint DELETE/PUT ni acción replicada todavía).
 */
export function usePendiente() {
  const [aviso, setAviso] = useState('')
  return { aviso, setAviso }
}
